/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get */
import Controller from '@ember/controller';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import { optionAlias } from '@linc-technologies/linced-common/utils/options';

export default class FinanceController extends Controller {
  @service
  features;

  @service
  options;

  @service
  router;

  @service
  strings;

  @computed('router.currentRouteName')
  get currentTab() {
    return this.get('router.currentRouteName').split('.')[2];
  }

  @optionAlias('finance:xero:enableXeroIntegration')
  xeroIntegrationEnabled;

  @action
  noop() {}
}
